import { render, staticRenderFns } from "./RestockListIframe.vue?vue&type=template&id=320a1ada&"
import script from "./RestockListIframe.vue?vue&type=script&lang=ts&"
export * from "./RestockListIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports